export default __webpack_public_path__ + "static/media/employee.03581a6c.svg";